export default "__VITE_ASSET__CIjnMxm1__"